import privateBusRequest from "./privateBusRequest.component";
import privateBusRequestUrls from "./privateBusRequest.urls";
import PrivateBusRequestTransforms from "./privateBusRequest.transforms";

const privateBusRequestModule = angular
  .module("app.components.privateBusRequest", [])
  .component("privateBusRequestPage", privateBusRequest)
  .service("PrivateBusRequestTransforms", PrivateBusRequestTransforms)
  .config(privateBusRequestUrls);

export default privateBusRequestModule;



// WEBPACK FOOTER //
// ./src/pages/privateBusRequest/privateBusRequest.module.js